<template>
	<ajax-form method="POST" :action="action" @success="handleSuccess" :data="supportData" v-model:loading="isLoading" v-model:valid="isValid" reset>

		<form-remote-select v-if="!event && !club" name="event_id"
							:disabled="isLoading"
							:action="'/v1/events'"
							:data="{limit: 25}"
							as-guest
							v-model="supportData.event_id"
							clearable
							text-prop="display_name"
							image-prop="avatar_thumbnail"
							image-tile
							:image-ratio="3/2"
							:unselect="$t('label.general_request')"
							:label="$t('label.event')"/>

		<form-remote-select name="type"
							:disabled="isLoading"
							:filterable="false"
							v-model="supportData.type"
							as-guest
							:data="{only_selectable: true, model_type: receiver?.model_type}"
							:action="'/v1/support/types'"
							:rules="{required: true}"
							text-prop="text"
							value-prop="value"
							help-prop="description"
							:label="$t('input.support_ticket.type')"/>

		<form-input v-if="!$auth.loggedIn" name="name"
					v-model="supportData.name"
					:rules="{required: true, max: 50, min: 2}"
					:disabled="isLoading"
					:label="$t('label.your_name')"/>

		<form-input v-if="!$auth.loggedIn" name="email"
					type="email"
					v-model="supportData.email"
					:rules="{required: true, max: 190, min: 4}"
					:disabled="isLoading"
					:label="$t('label.your_email')"/>

		<form-textarea name="message" :label="$t('label.your_message')"
					   :disabled="isLoading"
					   rows="4"
					   v-model="supportData.message"
					   :rules="{required: true}"/>

		<form-file-input name="attachment"
						 :disabled="isLoading"
						 v-model="supportData.attachment"
						 :label="$t('label.attachment')"/>


		<form-checkbox name="restrictions" :rules="{accepted: true}"
					   :disabled="isLoading"
					   :label="$t('input.support_ticket.restrictions')"
					   v-model="supportData.restrictions"/>

		<btn color="success" type="submit" class="w-full mt-16" large :loading="isLoading" :disabled="!isValid || isLoading">
			<Icon :icon="icons.submit"/>
			<span>{{ $t('action.send') }}</span>
		</btn>

		<template v-if="(event || club)">
			<template v-if="email || phone">
				<divider :text="$t('conjunction.or')"/>

				<div class="w-full">
					<p v-if="email && phone" class="text-center mb-20">{{ $t('text.contact_by_email_or_phone') }}</p>
					<info-list>
						<info-list-item v-if="phone" :icon="icons.phone" :text="phone" center/>
						<info-list-item v-if="email" :icon="icons.email" center>
							<email :email="email"/>
						</info-list-item>
					</info-list>
				</div>
			</template>
		</template>
		<template v-else class="w-full">
			<divider :text="$t('conjunction.or')"/>
			<div class="w-full">
				<p class="text-center mb-20">{{ $t('text.contact_by_email_or_phone') }}</p>
				<info-list>
					<info-list-item :icon="icons.phone" text="+49 8531 41078 90" center/>
					<info-list-item :icon="icons.email" center>
						<email email="support@spoferan.com"/>
					</info-list-item>
				</info-list>
			</div>
		</template>
	</ajax-form>
</template>

<script>
import {mdiPhone} from '@mdi/js';
import {emailIcon, submitIcon} from "../../config";

export default {
	name: 'SupportForm',

	props: {
		action: {
			type: String,
			default: '/v1/support/tickets'
		},

		// The event to create the support ticket for
		event: {
			type: Object,
			default: null
		},

		// The club to create the support ticket for
		club: {
			type: Object,
			default: null
		},

		data: {
			type: Object,
			default: () => ({})
		},

		email: {
			type: String,
			default: null
		},

		phone: {
			type: String,
			default: null
		},
	},

	data() {
		return {
			supportData: {
				event_id: this.event?.id ?? null,
				club_id: this.club?.id ?? null,
				attachment: null,
				restrictions: false,
				...this.data
			},

			icons: {
				phone: mdiPhone,
				email: emailIcon,
				submit: submitIcon,
			},
			isLoading: false,
			isValid: false
		}
	},

	computed: {
		receiver() {
			return this.event ?? this.club;
		}
	},

	methods: {
		handleSuccess(data) {
			this.$analytics.trackEvent('contact', {
				location: this.receiver ? `${this.receiver.model_name}_support` : 'support',
				model_type_name: this.receiver ? this.receiver.model_name : undefined,
				model_key: this.receiver ? this.receiver._key : undefined,
			});

			this.$emit('success', data);
		}
	}
}
</script>
